import { assert, IGNORED, Test } from "oc-e2e-testrunner";
import {
  asDegree,
  assertElementZwischenMauern,
  assertSegmentIstLückenlosGefüllt,
  assertWarnungen,
  getInspiredArrangement,
  resetArrangement,
  setSternFormMitWinkelnLeerraumRechts,
  setSternFormMitWinkelnPlain,
} from "./utils";
import { v2 } from "oc-threejs/short3";
import * as Commons from "oc-commons/Commons";
import * as Maths3 from "oc-threejs/Maths3";
import * as Debugs from "oc-threejs/Debugs";
import {
  AngleInterval,
  findMatchingRotation,
  getAngleIntervalType,
  intervalIntersection,
  istEckadapter,
  istUMProfil,
  middleAngle,
  normalizeAngle,
  parseAngleIntervalDefinition,
  setPiForTests,
  sortAngleIntervals,
} from "../commons/AngleIntervals";
import { Pfosten } from "../arrangement/Pfosten";
import { UMProfil } from "../arrangement/UMProfil";
import { Strecke2 } from "../arrangement/grundrissFunctions";
import {
  getSollZwischenabstandVerbose,
  getZwischenabstandAnSeiteVerbose,
  LINKS,
  RECHTS,
} from "../arrangement/elementFunctions";
import { Segment } from "../arrangement/Segment";
import { setEmptyAsMauer } from "../components/zauneditor/ZaunCircleMenuItemEmptyAsMauer";

export default {
  name: "TestUeberstand",
};

const json_taupe_grau_eckpfosten = {
  inspiration: "Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau",
  zaunart: "Sichtschutz",
  serie: "SYSTEM",
  grundriss: {
    ecken: [
      {
        id: 22347,
        punkt: {
          x: -5.99,
          y: 0,
        },
      },
      {
        id: 22348,
        punkt: {
          x: 6.49,
          y: 0,
        },
      },
    ],
    kanten: [
      {
        ecken: [22347, 22348],
      },
    ],
  },
  segmente: [
    {
      breite: 12.48,
      partsAndPfosten: [
        {
          type: "Pfosten",
          x0: 8.14,
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Klemmpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          montageadapterAuswahlwert: "Montageadapter_mit",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
        {
          type: "Element",
          breite: 0.9,
          höhe: 1.8,
          snap: 0,
          isBreiteKonfigurierbar: true,
          x0: 8.205,
          füllungAuswahlwert: "Keramik Eiche",
          füllungAuswahlwertIndividualisiert: true,
          gehflügelAuswahlwert: "Gehflügel_links",
          drückerAuswahlwert: "Drücker_Knauf_edelstahl",
          profilzylinderAuswahlwert: "Profilzylinder_mit",
          öffnungAuswahlwert: "Öffnung_nach_innen",
          anschlagAuswahlwert: "Anschlag_links",
          schieberichtungAuswahlwert: "Schieberichtung_links",
          schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
          füllungsseiteAuswahlwert: "Füllungsseite_B",
          anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
          anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
          abschlussleisteAuswahlwertIndividualisiert: false,
          zubehörAnzahl: {
            Handsender: 0,
            "Handsender Design": 0,
            Schlüsselschalter: 0,
            "Funk-Codeschloss": 0,
            "Bluetooth Schalter": 0,
            "Connect Gateway": 0,
            Lichtschranke: 0,
            "Techniker Key": 0,
          },
          toröffnerAuswahlwert: "Toröffner_ohne",
          torschließerAuswahlwert: "Torschließer_ohne",
          form: "Rechteck",
          massAuswahlwert: "90x180_Easy",
          profilPosition: 2,
          showProfil: false,
          anschlussAufRechts: false,
          gehflügelbreite: 0,
          standflügelbreite: 0,
          torIstFertig: false,
          elementNr: 0,
          isStandardMass: true,
          detailSerie: "SYSTEM KERAMIK",
          anMauer: "AnMauer_nein",
          isMasselement: false,
          isBestellseite: false,
          elementID: 0,
        },
        {
          type: "Pfosten",
          x0: 9.09,
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Klemmpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          montageadapterAuswahlwert: "Montageadapter_mit",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
        {
          type: "Element",
          breite: 1.8,
          höhe: 1.8,
          snap: -1,
          isBreiteKonfigurierbar: true,
          x0: 9.145,
          füllungAuswahlwert: "SYSTEM Rhombus Anthrazit",
          füllungAuswahlwertIndividualisiert: false,
          gehflügelAuswahlwert: "Gehflügel_links",
          drückerAuswahlwert: "Drücker_Knauf_edelstahl",
          profilzylinderAuswahlwert: "Profilzylinder_mit",
          öffnungAuswahlwert: "Öffnung_nach_innen",
          anschlagAuswahlwert: "Anschlag_links",
          schieberichtungAuswahlwert: "Schieberichtung_links",
          schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
          füllungsseiteAuswahlwert: "Füllungsseite_B",
          anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
          anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
          abschlussleisteAuswahlwertIndividualisiert: false,
          profilKategorieAuswahlwert: "Dekorprofile_30cm_Zaunfeld_Rhombus",
          profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
          profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
          zubehörAnzahl: {
            Handsender: 0,
            "Handsender Design": 0,
            Schlüsselschalter: 0,
            "Funk-Codeschloss": 0,
            "Bluetooth Schalter": 0,
            "Connect Gateway": 0,
            Lichtschranke: 0,
            "Techniker Key": 0,
          },
          toröffnerAuswahlwert: "Toröffner_ohne",
          torschließerAuswahlwert: "Torschließer_ohne",
          form: "Rechteck",
          massAuswahlwert: "180x180_Easy",
          profilPosition: 24,
          showProfil: null,
          anschlussAufRechts: false,
          gehflügelbreite: 0,
          standflügelbreite: 0,
          torIstFertig: false,
          elementNr: 1,
          isStandardMass: true,
          detailSerie: "SYSTEM RHOMBUS",
          anMauer: "AnMauer_nein",
          isMasselement: false,
          isMassProfil: false,
          isBestellseite: false,
          elementID: 0,
        },
        {
          type: "Pfosten",
          x0: 10.92,
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Klemmpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          montageadapterAuswahlwert: "Montageadapter_mit",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
        {
          type: "Element",
          breite: 1.69,
          höhe: 1.8,
          snap: -1,
          isBreiteKonfigurierbar: true,
          x0: 10.975,
          füllungAuswahlwert: "SYSTEM Rhombus Anthrazit",
          füllungAuswahlwertIndividualisiert: false,
          gehflügelAuswahlwert: "Gehflügel_links",
          drückerAuswahlwert: "Drücker_Knauf_edelstahl",
          profilzylinderAuswahlwert: "Profilzylinder_mit",
          öffnungAuswahlwert: "Öffnung_nach_innen",
          anschlagAuswahlwert: "Anschlag_links",
          schieberichtungAuswahlwert: "Schieberichtung_links",
          schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
          füllungsseiteAuswahlwert: "Füllungsseite_B",
          anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
          anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
          abschlussleisteAuswahlwertIndividualisiert: false,
          profilKategorieAuswahlwert: "Lichtleiste_Rhombus",
          profilAuswahlwert: "SYSTEM_Lichtleiste_Rhombus_Anthrazit",
          profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
          zubehörAnzahl: {
            Handsender: 0,
            "Handsender Design": 0,
            Schlüsselschalter: 0,
            "Funk-Codeschloss": 0,
            "Bluetooth Schalter": 0,
            "Connect Gateway": 0,
            Lichtschranke: 0,
            "Techniker Key": 0,
          },
          toröffnerAuswahlwert: "Toröffner_ohne",
          torschließerAuswahlwert: "Torschließer_ohne",
          form: "Rechteck",
          massAuswahlwert: "180x180_Easy",
          profilPosition: 30,
          showProfil: null,
          anschlussAufRechts: false,
          gehflügelbreite: 0,
          standflügelbreite: 0,
          torIstFertig: false,
          elementNr: 2,
          isStandardMass: false,
          detailSerie: "SYSTEM RHOMBUS",
          anMauer: "AnMauer_nein",
          isMasselement: false,
          isBestellseite: false,
          elementID: 0,
        },
        {
          type: "Pfosten",
          x0: 12.64,
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Klemmpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          montageadapterAuswahlwert: "Montageadapter_ohne",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      ],
      verteilungsstrategieAuswahlwert: "Individuell",
    },
  ],
  ecken: [
    {
      position: {
        x: -5.99,
        y: 0,
        z: 0,
      },
    },
    {
      position: {
        x: 6.49,
        y: 0,
        z: 0,
      },
    },
  ],
  aufbauten: [],
  pfostenartAuswahlwert: "Klemmpfosten",
  pfostenfarbeAuswahlwert: "Anthrazit",
  bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
  elementhalterAuswahlwert: "2096 Elementhalter",
  verteilungsstrategieAuswahlwert: "StandardLinks",
  montageadapterAuswahlwert: "Montageadapter_mit",
  verbundankerAuswahlwert: "Verbundanker-Set_mit",
};

const mapit = (s: Segment) =>
  s.getPartsAndPfostenWithoutEmpties().map((p) => ({
    type: p.meta?.Key ?? p.constructor.CLASS_NAME,
    id: p.id,
    x: p.position.x,
  }));

export const testEckpfostenSollSelektierbarSein: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.fromJSON(json_taupe_grau_eckpfosten);
  agt.update3d();
  const s = agt.segmente[0];

  // Prüfe, ob alle Objekte ihre Identität beibehalten, d.h. keine Objekte werden abgeräumt und neu erzeugt
  for (let i = 0; i < 5; i++) {
    const m1 = mapit(s);
    agt.update3d();
    const m2 = mapit(s);
    assert.deepEquals(m1, m2);
  }

  // Prüfe explizit noch mal den ursprünglichen Bug: Der Endpfosten ist nicht selektierbar, da jedesmal neu erzeugt
  agt.setSelectedObjects([agt.getPfosten().at(-1)]);
  agt.update3d();
  assert.equals(1, agt.selectedObjects.length);
};

export const testFüllungÄnderbar: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.fromJSON(json_taupe_grau_eckpfosten);
  agt.update3d();

  const rhombus_weiss = APP.richMetadata.findAuswahlwert("SYSTEM Rhombus Weiß");
  // Hier kommt es zu einem Bug
  agt.auswahlAccessoren.Füllung.setter(rhombus_weiss);
  assert.deepEquals(
    [
      "2919 SYSTEM KERAMIK Eiche 90 x 180 cm",
      "2951 SYSTEM RHOMBUS Weiß 180 x 180 cm",
      "2951 SYSTEM RHOMBUS Weiß 180 x 180 cm",
    ],
    agt.getElemente().map((e) => e.meta?.Key)
  );
};

export const testFüllungÄnderbarRechts: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.fromJSON(json_taupe_grau_eckpfosten);
  agt.update3d();
  Debugs.watch(APP.arrangement.getElemente()[0], "snap");
  //
  // const rhombus_weiss = APP.richMetadata.findAuswahlwert("SYSTEM Rhombus Weiß");
  // // Hier kommt es zu einem Bug
  // agt.auswahlAccessoren.Füllung.setter(rhombus_weiss);
  // assert.deepEquals(
  //   [],
  //   agt.getElemente().map((e) => e.meta?.Key)
  // );

  // Problem ist der Überstand von 24 cm, wodurch bei einfachen Änderungen die Anlage nach links springt.
  // Frage: An welcher Stelle wird die x-Position verändert? Gibt es einen Schwellwert für den Überstand, eine Korrektur?

  // Das Problem scheint ab 5 cm Überstand aufzutreten. Nach einer Füllungs-Änderung springen die Elemente.
};

export const testUeberstandLinksEndpfosten: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[1].uiRemove();
  agt.update3d();
  const empty = s.getEmpties()[0];
  empty.setKonfigurierbareBreite(empty.breite + 0.2);
  agt.update3d();
  const m1 = mapit(s);
  agt.update3d();
  const m2 = mapit(s);
  assert.deepEquals(m1, m2);
  // Prüfe explizit noch mal den ursprünglichen Bug: Der Endpfosten ist nicht selektierbar, da jedesmal neu erzeugt
  agt.setSelectedObjects([s.getPfosten().at(0)]);
  agt.update3d();
  assert.equals(1, agt.selectedObjects.length);
};

export const testUeberstandRechtsEndpfosten: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const empty = s.getEmpties()[0];
  empty.setKonfigurierbareBreite(empty.breite + 0.2);
  agt.update3d();
  const m1 = mapit(s);
  agt.update3d();
  const m2 = mapit(s);
  assert.deepEquals(m1, m2);
  // Prüfe explizit noch mal den ursprünglichen Bug: Der Endpfosten ist nicht selektierbar, da jedesmal neu erzeugt
  agt.setSelectedObjects([s.getPfosten().at(-1)]);
  agt.update3d();
  assert.equals(1, agt.selectedObjects.length);
};

export const testMauerMitÜberstandWirdTransparent: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [5]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const elemente = s.getElemente();
  elemente[0].uiRemove();
  elemente[2].uiRemove();
  agt.update3d();
  const mauern = s.empties.map(setEmptyAsMauer);
  mauern[0].size.x += 0.5;
  APP.dirty();
  await Commons.sleep(300);
  assert.deepEquals(
    [
      {
        hatKollision: true,
        opacity: 0.3,
      },
      {
        hatKollision: false,
        opacity: 1,
      },
    ],
    mauern.map((m) => ({ hatKollision: m.hatKollision, opacity: m.jaco3d.opacity }))
  );
};
